// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3w3qZ","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1tB9q","obliqueLine":"membershipbadge_obliqueLine__3h0Fn"};